export default {
    methods: {
        getTemplateByName(name) {
            if (this.templates != null && this.templates.length > 0) {
                return this.templates.find(function (element) {
                    return element.name === name && element.content != null;
                });
            } else {
                return null;
            }
        },
        getPropertyByName(name) {
            if (this.properties != null && this.properties.length > 0) {
                return this.properties.find(function (element) {
                    return element.name === name;
                });
            } else {
                return null;
            }
        },
        productByType(productType) {
            return this.products.find(p => p.productType === productType);
        },
        scrollToTop() {
            window.scrollTo(0, 0);
        }
    }
};
